const validate = (value: any): string | undefined => {
	if (!value || value === '') {
		return 'This field is required'
	}
}

export default validate
